import { Injectable } from '@angular/core';

/**
 * This class is encapsulating some methods for calculating and setting absolute/relative positions of elements.
 * This is mainly used to synchronize the position of draggable Elements across connected clients.
 */
@Injectable()
export class HTMLElementPositioningHelper {
  constructor() { }

  getRelativePositionOfElement(element: HTMLElement): any {
    const clientRect = element.getBoundingClientRect();
    return this.getRelativePosition(clientRect.left, clientRect.top);
  }

  /**
   * This transforms an absolute position
   * i.e. (100 / 400) meaning 100 pixel from the left of the screen, 400 pixels from the top of the screen
   * to a position relative to the clients Viewport
   * i.e (0.3 / 0.5) meaning 30% from the left and 50% from the top of viewport.
   */
  getRelativePosition(x: number, y: number): any {
    const percentViewportTop = (y / (document.documentElement.clientHeight));
    const percentViewportLeft = (x / (document.documentElement.clientWidth));
    const position = { 'left': percentViewportLeft, 'top': percentViewportTop };
    return position;
  }

  setRelativePosition(element: HTMLElement, positionLeft: number, positionTop: number, parentElement?: HTMLElement,
    scaleFactor = 1) {
    let offsetX = 0;
    let offsetY = 0;

    if (parentElement) {
      const parentRect = parentElement.getBoundingClientRect();
      offsetX = parentRect.left;
      offsetY = parentRect.top;
    }

    const translateX = (document.documentElement.clientWidth * positionLeft) - offsetX;
    const translateY = (document.documentElement.clientHeight * positionTop) - offsetY;
    this.setPosition(element, translateX, translateY, scaleFactor);
  }

  setAbsolutePosition(element: HTMLElement, x: number, y: number, scaleFactor = 1) {
    const translateX = x - element.getBoundingClientRect().left;
    const translateY = y - element.getBoundingClientRect().top;
    this.setPosition(element, translateX, translateY, scaleFactor);
  }

  private setPosition(element: HTMLElement, translateX: number, translateY: number, scaleFactor: number) {
    const transformString = 'translate(' + translateX + 'px, ' + translateY + 'px) scale(' + scaleFactor + ',' + scaleFactor + ')';
    element.style.transform = transformString;
    element.style.webkitTransform = transformString;
    element.setAttribute('data-x', translateX.toString());
    element.setAttribute('data-y', translateY.toString());
  }

  /**
   * Returns screen coordinates (x, y) based on the mouse-event-location and cardElement-size.
   * Use these coordinates to place a newly created card.
   */
  getPositionForNewCard(event, cardElement): any {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    let posX = event.clientX;
    let posY = event.clientY;
    const viewportPadding = 25;

    if (event.clientX > viewportWidth - cardElement.clientWidth) {
      posX = viewportWidth - cardElement.clientWidth - viewportPadding;
    }
    if (event.clientY > viewportHeight - cardElement.clientHeight) {
      posY = viewportHeight - cardElement.clientHeight - viewportPadding;
    }
    return { x: posX, y: posY };
  }


}
